<template>
   <div class="account-content">
			<div class="container">
				<div class="account-box">
					<div class="account-wrapper">
						<div class="login-logo">
							<img src="@/assets/logo.png" class="login-logo" >
						</div>	

						<GoogleLogin class="gConnect" :params="params" :onSuccess="onSuccess" :onFailure="onFailure">
							<img src="@/assets/google.png">
						</GoogleLogin>
						<p v-if="error" class="error alert">You are not authenticated to use this system.</p>

					</div>
				</div>
			</div>
		</div>
</template>

<script>
import axios from "axios"
import GoogleLogin from 'vue-google-login';
export default {
    data(){
        return{
			params: {
                    client_id: "358870652406-jrk4f1lqhplhtfn7f51fic5htr7fb7lv"
                },
                // only needed if you want to render the button with the google ui
                renderParams: {
                    width: 250,
                    height: 50,
                    longtitle: true
                },
				error:false
        }
    },
	components:{
		GoogleLogin
	},
    created() {
        document.getElementById("body").classList.add("account-page");
    },
    methods:{
        login(e){
			e.preventDefault()
            this.$router.push({path:"/dashboard-admin"});
        },
		onSuccess(googleUser) {
			this.error = false
			console.log('Logged in as: ' + googleUser.getBasicProfile().getEmail());
			 var filters = [{
                match_phrase: {
                    e: this.$store.state.event
                }
            },
			{
                match_phrase: {
                    email: googleUser.getBasicProfile().getEmail()
                }
            }]
            axios.post(`${this.$store.state.api}hr_employee/_search`, {
                    from: 0,
                    size: 500,
                    query: {
                        bool: {
                            must: filters,
                        }
                    }
                })
                .then((response) => {
                    var p = response.data.hits.hits;
					if(p.length){
						var d = p[0]._source
							d.id = p[0]._id
						localStorage.setItem('user',JSON.stringify(d));
						this.$router.push({path:'/dashboard'});
						
					}else{
						this.error = true
					}
                })
                .catch((error) => {
                    console.log(error);
                })
			
		},
		onFailure(error) {
			console.log(error);
		}
    }
}
</script>
<style scoped>
.alert{
	text-align: center;
    color: white;
}
</style>